import 'ses'
import '../core/lockdown'
import { createRoot } from 'react-dom/client'

import { Client } from './world-client'
import { resolveClientAssetsUrl, resolveClientWsUrl } from './resolve-ws-url'

function App() {
  return (
    <Client
      wsUrl={() => resolveClientWsUrl(env.PUBLIC_WS_URL)}
      assetsUrl={() => resolveClientAssetsUrl()}
    />
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<App />)
